import { Grid, makeStyles, Table, TableBody, TableCell, TableRow, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { ModuleTypeTranslationKey } from "../../../model/Module";
import { UploadDocumentsTaskDetailsViewModel } from "../../../model/personTask/UploadDocumentsTaskDetailsViewModel";
import { GetTranslatedValueIntl } from "../../../model/Shared/TranslatedValue";
import { GetTranslation } from "../../../translations/GetTranslation";
import TranslatedMessage from "../../translations/TranslatedMessage";

type TaskDetailsProps = {
  taskDetails: UploadDocumentsTaskDetailsViewModel;
};

const useStyles = makeStyles({
  table: {
    "& td": {
      borderBottom: "none",
    },
    "& td:nth-child(1)": {
      width: "150px",
    },
  },
});

const TaskDetails = ({ taskDetails }: TaskDetailsProps) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Grid container direction="row">
      <Grid item xs={12}>
        <Typography><TranslatedMessage id="uploadDocumentsTask.instructions" /></Typography>
      </Grid>
      <Grid item xs={6}>
        <Table size="small" className={classes.table}>
          <TableBody>
            <TableRow>
              <TableCell align="left">
                <TranslatedMessage id="application.examLocationAndDate.moduleColumn" />
              </TableCell>
              <TableCell align="left">{GetTranslatedValueIntl(intl, taskDetails.moduleName)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <TranslatedMessage id="application.moduleSelector.typeColumn" />
              </TableCell>
              <TableCell align="left">
                {GetTranslation(intl, ModuleTypeTranslationKey[taskDetails.moduleType])}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <TranslatedMessage id="application.userSelector.examSession" />
              </TableCell>
              <TableCell align="left">{GetTranslatedValueIntl(intl, taskDetails.examSessionName)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left">
                <TranslatedMessage id="course.header" />
              </TableCell>
              <TableCell align="left">{GetTranslatedValueIntl(intl, taskDetails.courseName)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

export default TaskDetails;
